import ConnectIcon from './component'

export default ConnectIcon
